import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  CftLayout,
  CftHeader,
  CftSection,
  CftActionsButtons,
  CftTank,
  CftLeavingModal,
  CftOnboardingPoultry,
  CftExportData,
  CftHeaderSteps,
} from "../../components";
import routes from "../../utils/cftRoutes";
import { CattleMain } from "../../forms/cattle";
import useCftCattleValues, { PIGS_TABS } from "../../utils/useCftCattleValues";

import "../styles/progressDashboard.scss";

export default function PigsPage() {
  const { t } = useTranslation(["cftTurkey", "cftChickenBroiler", "cftCattle"]);
  const history = useHistory();
  const { store } = useCftCattleValues();
  const [showLeavingModal, setShowLeavingModal] = useState(false);
  const stopOverflow = () => {
    document.querySelector("body").style.overflowY = "hidden";
    document.querySelector("html").style.overflow = "hidden";
  };

  return (
    <CftLayout
      header={
        <CftHeader
          cropName={t("cftCattle:tag", "Bydło opasowe")}
          actions={
            <CftTank
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <CftExportData type="pigs" />
              <CftActionsButtons.CancelButton
                hasText={false}
                onClick={() => {
                  stopOverflow();
                  setShowLeavingModal(!showLeavingModal);
                }}
              />
            </CftTank>
          }
        />
      }
    >
      <CftSection
        withNoSpace
        header={
          <CftTank display="flex" flexDirection="column" alignItems="center">
            <h3 className="cft-wrapper">
              {t("cftCattle:title", "kalkulator emisji")}
            </h3>
            <h4 className="cft-wrapper">
              {t("cftCattle:tag", "Bydło opasowe")}
            </h4>
            <CftHeaderSteps store={store} tabs={PIGS_TABS} />
          </CftTank>
        }
      >
        <CattleMain />
        <CftOnboardingPoultry />
      </CftSection>
      <CftLeavingModal
        isVisible={showLeavingModal}
        hide={() => setShowLeavingModal(!showLeavingModal)}
        type="bothCalc"
        goToProfile={() => history.push(routes.MAIN)}
        dataReport={JSON.stringify(store)}
      />
    </CftLayout>
  );
}
